'use strict';

import { appState } from './appState.js';
import { setScroll } from './Scrolls.js';

export function togglableUrl(param, onCallback, offCallback, conf) {
    const self = this;

    self.param = param;
    self.onCallback = onCallback;
    self.offCallback = offCallback;
    self.conf = conf || {};
    self.oldScroll = null;
    self.hiddenBackOn = false;
    self.hiddenBackCallback = null;

    self.getUrl = function () {
        if (typeof self.conf.getUrl == 'undefined') {
            return location.href.toString();
        }
        if (typeof self.conf.getUrl == 'function') {
            return self.conf.getUrl();
        }
        return self.conf.getUrl;
    };

    self.setOn = function (skipHistory) {
        if (self.isOn) {
            return;
        } else {
            if (!self.onCallback(self)) {
                return;
            }
            self.isOn = true;
        }

        if (!skipHistory) {
            setTimeout(function () {
                self.setHistory();
            }, self.conf.addHistoryDelay || 0);
        }
    };

    self.setHistory = function () {
        appState.historyInstance.push(self.param);
    };

    self.setBack = function () {

    };

    self.setOff = function (skipHistory, oldScroll) {
        if (!self.isOn) {
            return;
        }

        if (!skipHistory && (typeof appState.historyInstance != 'undefined') && appState.historyInstance) {
            if (self.conf.scrollFix) {
                self.oldScroll = $(window).scrollTop();
            }
            appState.historyInstance.go(-1);
            return;
        }

        if (self.hiddenBackOn) {
            if (self.hiddenBackCallback) {
                setTimeout(function () {
                    self.hiddenBackCallback();
                }, 0);
            }
            return;
        }

        if (self.conf.scrollFix && oldScroll !== undefined) {
            self.oldScroll = oldScroll;
        }
        if (self.conf.scrollFix && self.oldScroll !== null) {
            setTimeout(function () {
                setScroll(self.oldScroll);
                self.oldScroll = null;
            }, 0);
        }

        self.offCallback(self);
        self.isOn = false;
    };

    self.hiddenBack = function (callback) {
        self.hiddenBackOn = true;
        if (callback) {
            self.hiddenBackCallback = callback;
        }
        self.setOff();
    };

    var url = new URL(self.getUrl());
    var searchParams = url.searchParams;

    self.isOn = searchParams.get(self.param) !== null ? true : false;

    appState.historyInstance.add(param, {
        value: self.isOn ? true : null,
        backCallback: function (change) {
            if (change.to) {
                self.setOn(true);
            } else {
                self.setOff(true);
            }
        },
        checkCallback: function (value) {
            return self.isOn ? true : null;
        }
    });
}